export default __webpack_public_path__ + "static/media/top2.8bc786a6.svg";